import React from "react";
import { Grid2 as Grid, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import useDebugInformation from "../../../../hooks/useDebugInformation";
import useNato from "../../../../hooks/useNato";
import {  temp, api, ui } from "../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";
import AddressUtils from "@utils/address";
import { StringProcessor } from "@utils/stringProcessor";
import SearchIcon from "@mui/icons-material/Search";
import { MemoizedInputProps, handleKeyPress, a11yProps } from "../helpers";

const name = "MemoizedPostcodeInput";

const MemoizedPostcodeInput = React.memo<MemoizedInputProps>(({ parent, prefix, inputName, xs, sm, disabled, form }) => {
    const monitored = useAppSelector(({ ui }) => ui[`${prefix}${inputName}`]);
    const helperText = useAppSelector(({ ui }) => ui[`${prefix}${inputName}HelperText`]);
    const activeSearch = useAppSelector(({ temp }) => temp[`${prefix}ActiveSearch`])
    const valid = useAppSelector(({ state }) => state[`${prefix}${inputName}Valid`]);
    const nato = useNato(inputName, monitored || "")

    useDebugInformation(`${parent}▷[${inputName}]`, { inputName, prefix, xs, sm, sanitized: monitored })
    return (
        (<Grid
            size={{
                xs: 12,
                sm: 6
            }}>
            <Tooltip title={nato} sx={{ maxWidth: "none" }} placement="right">
                <TextField value={monitored}
                    disabled={disabled}
                    error={!valid}
                    color={valid ? "primary" : "error"}
                    onKeyPress={(ev) => handleKeyPress(ev, valid, prefix)} // search for addresses on enter
                    helperText={!valid ? helperText : ""}
                    required
                    {...a11yProps(inputName, prefix, form)}
                    label={StringProcessor.camelToWords(inputName)}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <div onClick={() => { AddressUtils.searchAddresses({ prefix, temp, api, ui }); form && form.clear(prefix, `${prefix}Postcode`) }}><InputAdornment position="end"><IconButton size="small" disabled={!activeSearch} color="primary"><SearchIcon /></IconButton></InputAdornment> </div>
                            )
                        }
                    }} />
            </Tooltip>
        </Grid>)
    );
})

MemoizedPostcodeInput.displayName = name;

export default MemoizedPostcodeInput;